export const advisorEngagementSources = [
  { key: 'recruited', title: 'Recruited', colorPalette: 'purple' },
  { key: 'team', title: 'Startups.com team', colorPalette: 'yellow' },
  { key: 'ai', title: 'Wil.ai', colorPalette: 'teal' },
].map(x => ({ ...x, id: x.key }))

export const ADVISOR_ENGAGEMENT_SOURCE_AI = 'ai'
export const ADVISOR_ENGAGEMENT_SOURCE_TEAM = 'team'
export const ADVISOR_ENGAGEMENT_SOURCE_RECRUITED = 'recruited'
